import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { BreezeTestComponent } from './views/BreezeTest/BreezeTest.component';

import { LoginComponent } from './views/Login/Login.component';
import { RoleGuardService as RoleGuard } from './providers/authentication/role-guard.service';
import { Permisos } from './providers/authentication/permisos.service';
import { DescargaAppComponent } from './views/DescargaApp/DescargaApp.component';
import { AppHistoricoChartComponent } from './componentes/HistoricoChart/historicoChart.component';

export const routes: Routes = [

	// { path: '', component: LoginComponent },
	/*{ path: 'print',
		outlet: 'print',
		component: PrintLayoutComponent,
		children: [
		{ path: 'informe', component: AppImprimirChartComponent}
	]},*/
	{ path: 'Login', component: LoginComponent, pathMatch: 'full' },
	{ path: 'DescargaApp', component: DescargaAppComponent },
	{
		path: 'Conexion',
		component: BreezeTestComponent,
		canActivate: [RoleGuard],
		data: {
			 expectedRole: [Permisos.Test_menu]
		},
	},

	{ path: '', pathMatch: 'full', redirectTo: 'Login'},
	{ path: '**', pathMatch: 'full', redirectTo: 'Login' },
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.routes.ts